function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import asMailtoHref from './mailto';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ShareURLComponent = function ShareURLComponent(_ref) {
  var querydb = _ref.querydb,
    program = _ref.program,
    queryLength = _ref.queryLength,
    url = _ref.url;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  var copyToClipboard = function copyToClipboard() {
    navigator.clipboard.writeText(url);
    setCopied(true);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "px-6 share-url-component",
    children: [/*#__PURE__*/_jsx("input", {
      className: "w-full mb-3 pt-3",
      name: "shareableUrl",
      type: "text",
      value: url,
      readOnly: true
    }), /*#__PURE__*/_jsxs("div", {
      className: "py-4 flex justify-between items-center",
      children: [/*#__PURE__*/_jsx("button", {
        className: "py-2 px-3 border border-transparent rounded-md shadow-sm text-white bg-seqblue hover:bg-seqorange focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-seqorange",
        onClick: copyToClipboard,
        children: copied ? 'Copied!' : 'Copy to Clipboard'
      }), /*#__PURE__*/_jsx("a", {
        href: asMailtoHref(querydb, program, queryLength, url, true),
        children: "Share via email"
      })]
    })]
  });
};
export default ShareURLComponent;